(() => {
  const initialize = () => {
  const once = selector => [...document.querySelectorAll(selector)].filter(element => {
    if (element.dataset.stillBound) return false;
    element.dataset.stillBound = 'true';
    return true;
  });
  const root = document.body.dataset.rootUrl || '/';
  const menu = document.querySelector('#StillMobileMenu');
  once('[data-open-menu]').forEach(button => button.addEventListener('click', () => document.querySelector('#StillMobileMenu')?.showModal()));
  once('[data-close-dialog]').forEach(button => button.addEventListener('click', () => button.closest('dialog')?.close()));
  once('dialog').forEach(dialog => {
    dialog.addEventListener('click', event => {
      if (event.target === dialog) {
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      }
    });
  });
  once('[data-gallery]').forEach(gallery => {
    const main = gallery.querySelector('[data-main-image]');
    const count = gallery.querySelector('[data-gallery-count]');
    const thumbnails = [...gallery.querySelectorAll('[data-gallery-src]')];
    thumbnails.forEach((button, index) => {
      button.addEventListener('click', () => {
        if (!main) return;
        main.src = button.dataset.gallerySrc;
        main.removeAttribute('srcset');
        main.alt = button.dataset.galleryAlt || main.alt;
        thumbnails.forEach(t => t.setAttribute('aria-pressed', String(t === button)));
        if (count) count.textContent = `${String(index + 1).padStart(2, '0')} / ${String(thumbnails.length).padStart(2, '0')}`;
      });
      button.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        const target = thumbnails[(index + (event.key === 'ArrowRight' ? 1 : -1) + thumbnails.length) % thumbnails.length];
        target.focus(); target.click();
      });
    });
  });
  once('[data-product-form]').forEach(form => {
    const selector = form.querySelector('[name="id"]');
    const submit = form.querySelector('[name="add"]');
    const status = form.querySelector('[role="status"]');
    selector?.addEventListener('change', () => {
      const option = selector.selectedOptions?.[0];
      if (!option) return;
      const available = option.dataset.available === 'true';
      submit.disabled = !available;
      submit.textContent = available ? 'Add to bag' : 'Sold out';
      const price = document.querySelector('[data-product-price]');
      if (price && option.dataset.price) price.textContent = option.dataset.price;
      const total = document.querySelector('[data-single-box-total]');
      if (total && option.dataset.boxTotal) total.textContent = option.dataset.boxTotal;
      const quantity = form.querySelector('[name="quantity"]');
      if (quantity) { quantity.min = option.dataset.min || '1'; quantity.step = option.dataset.step || '1'; quantity.value = quantity.min; if (option.dataset.max) quantity.max = option.dataset.max; else quantity.removeAttribute('max'); }
      const address = new URL(window.location.href); address.searchParams.set('variant', option.value); history.replaceState({}, '', address);
    });
    form.addEventListener('submit', async event => {
      if (!window.fetch || !status) return;
      event.preventDefault();
      if (document.body.dataset.preview === 'true') {
        try { window.STILLPreviewCart.add(new FormData(form)); window.location.assign(`${root}cart`); } catch(error) { status.textContent = error.message; }
        return;
      }
      submit.disabled = true; status.textContent = 'Adding to your bag…';
      try {
        const response = await fetch(`${root}cart/add.js`, {method:'POST',headers:{Accept:'application/json'},body:new FormData(form)});
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || 'This item could not be added. Please try again.');
        window.location.assign(`${root}cart`);
      } catch (error) {
        status.textContent = error.message || 'Something went wrong. Please try again.';
        status.classList.add('form-status--error'); submit.disabled = false;
      }
    });
  });
  // Preview forms deliberately do not collect or persist data. Live forms are Shopify Forms app blocks.
  once('[data-preview-form]').forEach(form => {
    form.addEventListener('submit', event => {
      event.preventDefault();
      const status = form.querySelector('[role="status"]');
      if (!form.reportValidity()) return;
      status.textContent = 'Preview only — nothing was sent or saved. The published store will use the connected Shopify form.';
    });
    const interest = new URLSearchParams(location.search).get('style');
    const select = form.querySelector('[name="interest"]');
    if (select && ['tulip','belle','koda'].includes(interest)) select.value = interest;
  });
  };
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
